
<nz-tabs>
    <nz-tab nzTitle="Add Stock Item">
        <div nz-col nzSpan="24" style="margin: 16px;">
            <div style="display: flex; gap: 8px; margin-bottom: 16px;">
                <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Select Brand" [(ngModel)]="selectedBrandId" style="width: 50%; margin-right: 8px;">
                    @for (brand of brandNames(); track brand.value) {
                        <nz-option [nzValue]="brand.value" [nzLabel]="brand.text" (click)="selectedBrandId.set(brand.value)"></nz-option>
                    }
                </nz-select>
                <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Select Size" [(ngModel)]="selectedSize" style="width: 50%;">
                    @for (size of sizeOptions(); track size.value) {
                        <nz-option [nzValue]="size.value" [nzLabel]="size.text" (click)="selectedSize.set(size.value)"></nz-option>
                    }
                </nz-select>
            </div>
            <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Select a Stock Item" [(ngModel)]="selectedStockItem" style="width: 100%;">
                @for (item of filteredStockItems(); track item.msfId) {
                    <nz-option [nzValue]="item" [nzLabel]="item.description + ' ' + item.tyreBrand"></nz-option>
                }
            </nz-select>
            <form [formGroup]="stockForm" nz-form nzLayout="vertical">
                <label>{{selectedStockItem()?.description}}</label>
                <nz-form-item>
                    <nz-form-label>Stock Code</nz-form-label>
                    <nz-form-control>
                        <input nz-input placeholder="Enter stock code" formControlName="stockCode"/>
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                    <nz-form-label>Cost</nz-form-label>
                    <nz-form-control>
                        <input nz-input placeholder="Enter cost" formControlName="cost"/>
                    </nz-form-control>
                </nz-form-item>
                <button nz-button nzType="primary" (click)="addStockItem()" [disabled]="stockForm.invalid">Add Stock Item</button>
            </form>
        </div>
    </nz-tab>
    <nz-tab nzTitle="Add Custom Stock Item">
        <div style="padding: 16px;">
            <form [formGroup]="stockCustomForm" nz-form nzLayout="vertical" >
                <nz-form-item>
                    <nz-form-label>Description</nz-form-label>
                    <nz-form-control>
                        <input nz-input placeholder="Enter description" formControlName="description"/>
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                    <nz-form-label>Stock Code</nz-form-label>
                    <nz-form-control>
                        <input nz-input placeholder="Enter stock code" formControlName="stockCode"/>
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                    <nz-form-label>Cost</nz-form-label>
                    <nz-form-control>
                        <input nz-input placeholder="Enter cost" formControlName="cost"/>
                    </nz-form-control>
                </nz-form-item>
                <button nz-button nzType="primary" (click)="addCustomStockItem()" [disabled]="stockCustomForm.invalid">Add Custom Stock Item</button>
            </form>
        </div>
    </nz-tab>
</nz-tabs>
